export const getSeasonalMode = () => {
  // ---------- STAFF OVERRIDE ----------
  const params = new URLSearchParams(window.location.search);
  const forcedSeason = params.get("season");

  const allowed = [
    "halloween",
    "christmas",
    "lunar",
    "newyear",
    "easter",
    "thanksgiving",
    "valentines",
  ];

  if (forcedSeason && allowed.includes(forcedSeason)) {
    return forcedSeason;
  }

  // ---------- DATE LOGIC ----------
  const today = new Date();
  const year = today.getFullYear();

  const withinRange = (month, day) => {
    const target = new Date(year, month, day);
    const diff = (target - today) / (1000 * 60 * 60 * 24);
    return diff <= 14 && diff >= 0;
  };

  const withinExactRange = (startMonth, startDay, endMonth, endDay) => {
    const start = new Date(year, startMonth, startDay);
    const end = new Date(year, endMonth, endDay);
    return today >= start && today <= end;
  };

  if (withinRange(9, 31)) return "halloween";        // Oct 31
  if (withinRange(11, 25)) return "christmas";       // Dec 25
  if (withinExactRange(1, 7, 1, 14)) return "valentines";  // Feb 7-14
  if (withinRange(0, 1)) return "newyear";           // Jan 1
  if (withinRange(2, 31)) return "easter";           // late March/April
  if (withinRange(9, 14)) return "thanksgiving";     // Canada Oct 2nd Mon
  if (withinExactRange(1, 17, 1, 17)) return "lunar"; // Feb 17 only

  return null;
};
